import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";
import storageSession from "redux-persist/es/storage/session";

type CustomerExport = {
  tncAgreement: boolean;
  showTnC: boolean;
  isShowExport: boolean;
};

const initialState: CustomerExport = {
  tncAgreement: false,
  showTnC: false,
  isShowExport: false,
};

const { actions, reducer } = createSlice({
  name: "customerExport",
  initialState,
  reducers: {
    showExport: (state) => ({
      ...state,
      isShowExport: true,
    }),
    hideExport: (state) => ({
      ...state,
      isShowExport: false,
    }),
    toggleTnC: (state) => ({
      ...state,
      showTnC: !state.showTnC,
    }),
    acceptTnCAgreement: (state) => ({
      ...state,
      tncAgreement: true,
    }),
    declineTnCAgreement: (state) => ({
      ...state,
      tncAgreement: false,
    }),
  },
});

export const { showExport, hideExport, toggleTnC, acceptTnCAgreement, declineTnCAgreement } = actions;

const customerExportPersistConfig = {
  key: "customerExport",
  storage: storageSession,
  stateReconciler: autoMergeLevel2,
  whitelist: ["tncAgreement"],
};

export default persistReducer<CustomerExport>(customerExportPersistConfig, reducer);
